import {
  GET_MATCHES,
  GET_MATCHES_SUCCESS,
  GET_MAIN_DRAW,
  GET_MAIN_DRAW_SUCCESS,
  API_ERROR,
  GET_LOGS_SUCCESS,
} from "./actionTypes"
const initialState = {
  error: "",
  matches: [],
  mainDraw: {},
  logs: [],
  loading: false,
  competitionId: null,
  reads: {},
}
export default function matches(state = initialState, action) {
  if (action.type === GET_LOGS_SUCCESS)
    return { ...state, logs: action.payload }
  if ([GET_MATCHES, GET_MAIN_DRAW].includes(action.type)) {
    const { competitionId, requestId } = action.payload
    const resource = action.type === GET_MATCHES ? "matches" : "mainDraw"
    const next =
      state.competitionId === competitionId
        ? state
        : { ...initialState, logs: state.logs }
    return {
      ...next,
      competitionId,
      loading: true,
      error: "",
      // A repeated read keeps its loaded flag so the page can hold the current
      // draw on screen while the refresh is in flight.
      reads: {
        ...next.reads,
        [resource]: {
          requestId,
          status: "loading",
          loaded: Boolean(next.reads[resource]?.loaded),
        },
      },
    }
  }
  if (
    [GET_MATCHES_SUCCESS, GET_MAIN_DRAW_SUCCESS, API_ERROR].includes(
      action.type
    )
  ) {
    const { competitionId, requestId, resource } = action.meta || {}
    // The API_ERROR name is shared with legacy event reducers. Only accept
    // a completion for this resource's latest read, including repeated refreshes.
    if (
      !resource ||
      state.competitionId !== competitionId ||
      state.reads[resource]?.requestId !== requestId
    )
      return state
    const failed = action.type === API_ERROR
    const reads = {
      ...state.reads,
      [resource]: {
        requestId,
        status: failed ? "error" : "success",
        error: failed ? action.payload : null,
        loaded: !failed || Boolean(state.reads[resource]?.loaded),
      },
    }
    return {
      ...state,
      reads,
      loading: Object.values(reads).some(read => read.status === "loading"),
      error: failed ? action.payload : "",
      ...(!failed && { [resource]: action.payload }),
    }
  }
  return state
}
